/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PlatformTaskUpdateRequest {
    getFixupPrototypeFunction() { return PlatformTaskUpdateRequest.fixupPrototype; }

    static newInstance(model: Partial<PlatformTaskUpdateRequest>): PlatformTaskUpdateRequest {
        let obj = Object.assign(new PlatformTaskUpdateRequest(), model);
        PlatformTaskUpdateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PlatformTaskUpdateRequest>): PlatformTaskUpdateRequest {
        if (!model) return null;
        return PlatformTaskUpdateRequest.newInstance(<PlatformTaskUpdateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PlatformTaskUpdateRequest) {
        if (!obj) return;

        models.PlatformTaskUpdateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PlatformTaskUpdateRequest): boolean {
        Object.setPrototypeOf(obj, PlatformTaskUpdateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique ID of the task to be updated
     */
    task_id: string;

    /**
     * Task to be updated
     */
    task: models.PlatformTasks;

    /**
     * Updated status of the task
     */
    status: models.PlatformTaskStatus;

}
